import React, { useState } from 'react'
import styled from 'styled-components'
import { Tabs, Tab } from '@mui/material'
import { addKeyToObjectsArray } from 'utils/addUniqueKeyToObjects'

const CustomTabs = styled(Tabs)`
  .MuiTab-wrapper {
    font-size: 1.4rem;
  }

  .Mui-selected {
    font-weight: 600;
  }

  .indicator {
    background-color: ${(props) => props.theme.palette.primary};
  }
`

const CustomizedTabs = (props) => {
  const { initialValue, tabs, onChange } = props
  const [activeTab, setActiveTab] = useState(initialValue || 0)
  
  const tabsWithKeys = addKeyToObjectsArray(tabs)

  const handleTabChange = (_, index) => {
    setActiveTab(index)
    onChange(index)
  }

  return (
    <CustomTabs
      value={activeTab}
      onChange={handleTabChange}
      classes={{ indicator: 'indicator' }}
    >
      {
        tabsWithKeys?.map((tab) => <Tab key={tab.key} label={tab.label} />)
      }
    </CustomTabs>
  )
}

export default CustomizedTabs
